import { Controller } from "@hotwired/stimulus"

// As the form's fields change, loads a check URL into a Turbo Frame with the
// form's current values, debounced so typing sends one request.
export default class extends Controller {
  static values = { url: String, frame: String, delay: { type: Number, default: 300 } }

  disconnect() {
    clearTimeout(this.timeout)
  }

  check() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.load(), this.delayValue)
  }

  load() {
    const url = new URL(this.urlValue, window.location.href)
    for (const [ name, value ] of new FormData(this.element)) {
      if (name !== "authenticity_token" && typeof value === "string") url.searchParams.set(name, value)
    }
    document.getElementById(this.frameValue)?.setAttribute("src", url.toString())
  }
}
